export default __webpack_public_path__ + "static/media/arkguide_01.c7be412d.gif";